/**
 * BODi Navigation
 *
 * Mobile UX:
 * - Hamburger opens the main menu (flat list of tabs)
 * - Tabs with data-mobile-dropdown-trigger slide open the submenu panel
 * - Inside the submenu panel, [data-mobile-accordion] buttons expand inline
 * - Back button returns to the main menu; Close button closes everything
 */
 
(function () {
  "use strict";
 
  setTimeout(() => {
    document.body.style.backgroundColor = "#161819";
  }, 1000);
 
  const urlParams = new URLSearchParams(window.location.search);
  const isDebugMode = urlParams.has("debugBodiNav");
 
  // ========================================
  // Desktop Navigation (unchanged)
  // ========================================
 
  function initializeDesktopNavTracking() {
    const desktopNav = document.querySelector(".bodi-nav-desktop");
    if (!desktopNav) return;
    desktopNav.addEventListener("click", (e) => {
      const link = e.target.closest("a");
      if (link && link.href && window.BODi?.trackSelectCta) {
        window.BODi.trackSelectCta("select nav cta", link.href);
      }
    });
  }
 
  function initializeDesktopNav() {
    const timeouts = { megaMenu: {}, miniMenu: {} };
 
    const submenuWrapper = document.querySelector(".bodi-nav__submenu-wrapper");
    const megaMenu = submenuWrapper?.querySelector(".bodi-nav__mega-menu");
    const categoryTabs = submenuWrapper?.querySelectorAll(".bodi-nav__category-tab");
 
    if (!submenuWrapper || !categoryTabs?.length) return;
 
    categoryTabs.forEach((tab) => {
      const isDirectLink =
        tab.tagName === "A" && tab.classList.contains("bodi-nav__category-tab--link");
      const menuType = tab.getAttribute("data-menu-type");
      const miniMenu = tab.querySelector(".bodi-nav__mini-menu");
 
      tab.addEventListener("mouseenter", () => {
        clearTimeout(timeouts.megaMenu.main);
        clearTimeout(timeouts.miniMenu.main);
        categoryTabs.forEach((t) => t.classList.remove("bodi-nav__category-tab--active"));
        tab.classList.add("bodi-nav__category-tab--active");
        submenuWrapper.querySelectorAll(".bodi-nav__mini-menu").forEach((m) => {
          m.classList.remove("bodi-nav__mini-menu--active");
        });
 
        if (isDirectLink) {
          megaMenu?.classList.remove("bodi-nav__mega-menu--active");
        } else if (menuType === "mini" && miniMenu) {
          miniMenu.classList.add("bodi-nav__mini-menu--active");
          megaMenu?.classList.remove("bodi-nav__mega-menu--active");
        } else if (menuType === "mega" && megaMenu) {
          megaMenu.classList.add("bodi-nav__mega-menu--active");
          const handle = tab.getAttribute("data-category");
          submenuWrapper
            .querySelectorAll(".bodi-nav__mega-menu-category-content")
            .forEach((c) => {
              c.classList.toggle(
                "bodi-nav__mega-menu-category-content--active",
                c.getAttribute("data-category-content") === handle
              );
            });
        }
      });
 
      if (!isDebugMode) {
        tab.addEventListener("mouseleave", () => {
          if (isDirectLink) {
            tab.classList.remove("bodi-nav__category-tab--active");
            return;
          }
          if (menuType === "mini" && miniMenu) {
            timeouts.miniMenu.main = setTimeout(() => {
              if (!miniMenu.matches(":hover")) {
                miniMenu.classList.remove("bodi-nav__mini-menu--active");
                tab.classList.remove("bodi-nav__category-tab--active");
              }
            }, 150);
          } else if (menuType === "mega") {
            timeouts.megaMenu.main = setTimeout(() => {
              if (megaMenu && !megaMenu.matches(":hover")) {
                megaMenu.classList.remove("bodi-nav__mega-menu--active");
                tab.classList.remove("bodi-nav__category-tab--active");
              }
            }, 150);
          }
        });
      }
 
      if (miniMenu) {
        miniMenu.addEventListener("mouseenter", () => {
          clearTimeout(timeouts.miniMenu.main);
          miniMenu.classList.add("bodi-nav__mini-menu--active");
        });
        if (!isDebugMode) {
          miniMenu.addEventListener("mouseleave", () => {
            timeouts.miniMenu.main = setTimeout(() => {
              miniMenu.classList.remove("bodi-nav__mini-menu--active");
              categoryTabs.forEach((t) => t.classList.remove("bodi-nav__category-tab--active"));
            }, 150);
          });
        }
      }
    });
 
    if (megaMenu) {
      megaMenu.addEventListener("mouseenter", () => {
        clearTimeout(timeouts.megaMenu.main);
        megaMenu.classList.add("bodi-nav__mega-menu--active");
      });
      if (!isDebugMode) {
        megaMenu.addEventListener("mouseleave", () => {
          timeouts.megaMenu.main = setTimeout(() => {
            megaMenu.classList.remove("bodi-nav__mega-menu--active");
            categoryTabs.forEach((t) => t.classList.remove("bodi-nav__category-tab--active"));
          }, 150);
        });
      }
    }
  }
 
  // ========================================
  // Mobile Navigation
  // ========================================
 
  function initializeMobileNavTracking() {
    const mobileNav = document.querySelector(".bodi-nav-mobile");
    if (!mobileNav) return;
    mobileNav.addEventListener("click", (e) => {
      const link = e.target.closest("a");
      if (link && link.href && window.BODi?.trackSelectCta) {
        window.BODi.trackSelectCta("select nav cta", link.href);
      }
    });
  }
 
  function initializeMobileNav() {
    const state = {
      menuOpen: false,
      submenuOpen: false,
      activeTabId: null,
      scrollPosition: 0,
    };
 
    // DOM refs
    const hamburgerBtn     = document.getElementById("bodiNavMobileHamburgerBtnV2");
    const menuOverlay      = document.getElementById("bodiNavMobileMenuOverlayV2");
    const mainMenu         = document.getElementById("bodiNavMobileMainMenuV2");
    const submenu          = document.getElementById("bodiNavMobileSubmenuV2");
    const backBtn          = document.getElementById("bodiNavMobileBackBtnV2");
    const submenuTitle     = document.getElementById("bodiNavMobileSubmenuTitleV2");
 
    // ── Body scroll helpers ─────────────────────────────────────────────────
 
    function lockBodyScroll() {
      state.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      document.body.style.position = "fixed";
      document.body.style.top = `-${state.scrollPosition}px`;
      document.body.style.width = "100%";
      document.body.classList.add("bodi-nav-menu-open");
    }
 
    function unlockBodyScroll() {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      document.body.classList.remove("bodi-nav-menu-open");
      window.scrollTo(0, state.scrollPosition);
    }
 
    // ── Main menu ───────────────────────────────────────────────────────────
 
    function openMenu() {
      state.menuOpen = true;
      lockBodyScroll();
      menuOverlay.classList.add("bodi-nav-mobile__menu-overlay--active");
    }
 
    function closeMenu() {
      state.menuOpen = false;
      state.submenuOpen = false;
      state.activeTabId = null;
      unlockBodyScroll();
      menuOverlay.classList.remove("bodi-nav-mobile__menu-overlay--active");
      // Reset submenu state
      submenu.classList.remove("bodi-nav-mobile__submenu--active");
      mainMenu.classList.remove("bodi-nav-mobile__main-menu--hidden");
      hideAllPanels();
      collapseAllAccordions();
    }
 
    // ── Submenu panel ───────────────────────────────────────────────────────
 
    function hideAllPanels() {
      document.querySelectorAll(".bodi-nav-mobile__submenu-panel").forEach((p) => {
        p.hidden = true;
      });
    }
 
    function openSubmenu(tabId, tabTitle) {
      hideAllPanels();
 
      const panel = document.getElementById(`submenu-panel-${tabId}`);
      if (!panel) return;
 
      state.submenuOpen = true;
      state.activeTabId = tabId;
 
      if (submenuTitle) submenuTitle.textContent = tabTitle;
      panel.hidden = false;
 
      mainMenu.classList.add("bodi-nav-mobile__main-menu--hidden");
      submenu.classList.add("bodi-nav-mobile__submenu--active");
    }
 
    function closeSubmenu() {
      state.submenuOpen = false;
      state.activeTabId = null;
      collapseAllAccordions();
      hideAllPanels();
      submenu.classList.remove("bodi-nav-mobile__submenu--active");
      mainMenu.classList.remove("bodi-nav-mobile__main-menu--hidden");
    }
 
    // ── Accordion helpers ───────────────────────────────────────────────────
 
    function openAccordion(btn) {
      const handle = btn.getAttribute("data-mobile-accordion");
      const panel = btn.nextElementSibling;
      if (!panel || !panel.classList.contains("bodi-nav-mobile__accordion-panel")) return;
 
      // Collapse any other open accordion first
      document.querySelectorAll("[data-mobile-accordion]").forEach((other) => {
        if (other !== btn && other.getAttribute("aria-expanded") === "true") {
          closeAccordion(other);
        }
      });
 
      // Populate from pre-rendered template
      const tpl = document.querySelector(`script[data-category-content="${handle}"]`);
      if (tpl) panel.innerHTML = tpl.innerHTML;
 
      btn.setAttribute("aria-expanded", "true");
      const toggle = btn.querySelector(".bodi-nav-mobile__accordion-toggle");
      if (toggle) toggle.textContent = "−";
 
      // Animate open: measure natural height, then transition to it
      panel.style.maxHeight = "0";
      panel.style.overflow = "hidden";
      panel.hidden = false;
      // Force reflow so transition fires
      panel.getBoundingClientRect();
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
 
    function closeAccordion(btn) {
      const panel = btn.nextElementSibling;
      if (!panel || !panel.classList.contains("bodi-nav-mobile__accordion-panel")) return;
 
      btn.setAttribute("aria-expanded", "false");
      const toggle = btn.querySelector(".bodi-nav-mobile__accordion-toggle");
      if (toggle) toggle.textContent = "+";
 
      // Animate closed: collapse to 0, then hide and clear after transition
      panel.style.maxHeight = panel.scrollHeight + "px";
      // Force reflow
      panel.getBoundingClientRect();
      panel.style.maxHeight = "0";
 
      panel.addEventListener("transitionend", function handler() {
        panel.removeEventListener("transitionend", handler);
        panel.hidden = true;
        panel.innerHTML = "";
        panel.style.maxHeight = "";
        panel.style.overflow = "";
      }, { once: true });
    }
 
    function collapseAllAccordions() {
      document.querySelectorAll("[data-mobile-accordion]").forEach((btn) => {
        if (btn.getAttribute("aria-expanded") === "true") {
          closeAccordion(btn);
        }
      });
    }
 
    // ── Wire up events ──────────────────────────────────────────────────────
 
    hamburgerBtn?.addEventListener("click", openMenu);
 
    // All close buttons
    document.querySelectorAll(".bodi-nav-mobile__close-btn").forEach((btn) => {
      btn.addEventListener("click", closeMenu);
    });
 
    // Tap outside to close
    menuOverlay?.addEventListener("click", (e) => {
      if (e.target === menuOverlay) closeMenu();
    });
 
    // Back button returns to main menu
    backBtn?.addEventListener("click", closeSubmenu);
 
    // Dropdown tab triggers
    document.querySelectorAll("[data-mobile-dropdown-trigger]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const tabId = btn.getAttribute("data-mobile-dropdown-trigger");
        const tabTitle = btn.querySelector(".bodi-nav-mobile__accordion-title")?.textContent?.trim() || "";
        openSubmenu(tabId, tabTitle);
      });
    });
 
    // Accordion toggles — bound directly on each button, not delegated
    function initAccordionListeners() {
      document.querySelectorAll("[data-mobile-accordion]").forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.stopPropagation();
          const isOpen = btn.getAttribute("aria-expanded") === "true";
          isOpen ? closeAccordion(btn) : openAccordion(btn);
        });
      });
    }
    initAccordionListeners();
 
    // Close menu on footer link click
    document.querySelectorAll(".bodi-nav-mobile__footer-link-item").forEach((link) => {
      link.addEventListener("click", closeMenu);
    });
 
    // Close the whole nav when any link inside the overlay is clicked
    menuOverlay?.addEventListener("click", (e) => {
      const link = e.target.closest("a[href]");
      if (link) closeMenu();
    });
  }
 
  // ========================================
  // Cart Button Handlers
  // ========================================
 
  function initializeCartButtons() {
    const bodiCartButtons = document.querySelectorAll(
      ".bodi-nav__cart-button, .bodi-nav-mobile__cart-button"
    );
    const rebuyDisabled = window.BODi?.configs?.rebuy?.smartCartDisabled ?? false;
 
    bodiCartButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        if (!rebuyDisabled) return;
        if (window.RechargePubSub) {
          window.RechargePubSub.publish("cart-drawer:open");
          return;
        }
        event.preventDefault();
        const drawer = document.querySelector("cart-drawer-component");
        if (drawer) {
          drawer.open();
        } else {
          document.querySelector("cart-icon")?.click();
        }
      });
    });
  }
 
  // ========================================
  // Init
  // ========================================
 
  function intializeNav() {
    initializeDesktopNav();
    initializeDesktopNavTracking();
    initializeMobileNav();
    initializeMobileNavTracking();
    initializeCartButtons();
  }
 
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", intializeNav);
  } else {
    intializeNav();
  }
})();